import React, { useState } from "react";

import {
  CourtWrapper,
  CourtHeader,
  CourtHeaderButton,
  CourtTitle,
  Tabs,
  TabButton,
  NoMatches
} from "./court.styles";

import Match from "./Match";
import { getDefaultTab, hasAnyMatches } from "./courtUtils";

import chevronDownWhite from "./imgs/chevron-down-white.svg";
import chevronUpWhite from "./imgs/chevron-up-white.svg";
import chevronDownBlack from "./imgs/chevron-down.svg";
import chevronUpBlack from "./imgs/chevron-up.svg";

const Court = ({ courtName, matches, isOdd, isExpanded }) => {
  const [activeTab, setActiveTab] = useState(() => getDefaultTab(matches));
  const [expandedWrapper, setExpandedWrapper] = useState(isExpanded || false);

  if (!hasAnyMatches(matches)) return null;

  return (
    <CourtWrapper>
      <CourtHeader isOdd={isOdd}>
        <CourtTitle isOdd={isOdd}>{courtName}</CourtTitle>
        <CourtHeaderButton onClick={() => setExpandedWrapper(!expandedWrapper)}>
          {expandedWrapper ? (
            <img
              src={!isOdd ? chevronUpWhite : chevronUpBlack}
              alt="chevron-up"
            />
          ) : (
            <img
              src={!isOdd ? chevronDownWhite : chevronDownBlack}
              alt="chevron-down"
            />
          )}
        </CourtHeaderButton>
      </CourtHeader>
      {expandedWrapper && (
        <>
          <Tabs>
            <TabButton
              active={activeTab === "ended"}
              onClick={() => setActiveTab("ended")}
            >
              Completed
            </TabButton>
            <TabButton
              active={activeTab === "live"}
              onClick={() => setActiveTab("live")}
            >
              Live
            </TabButton>
            <TabButton
              active={activeTab === "upcoming"}
              onClick={() => setActiveTab("upcoming")}
            >
              Upcoming
            </TabButton>
          </Tabs>
          {matches[activeTab]?.length === 0 ? (
            <NoMatches>No matches to show</NoMatches>
          ) : (
            matches[activeTab]?.map((match, index) => (
              <Match key={index} match={match} courtName={courtName} />
            ))
          )}
        </>
      )}
    </CourtWrapper>
  );
};

export default Court;
